import React, { useContext, useEffect } from 'react'
import { EasybakeContext } from '../EasybakeProvider'
import analytics from '../../config/analytics'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import DropZone from '@react/react-spectrum/DropZone'
import Button from '@react/react-spectrum/Button'
import Delete from '@react/react-spectrum/Icon/Delete'
import Title from './Title'
import { logAlert } from '../../lib/easybake'
import AtnLogo from '../../asset/img/atn.png'

export default function UploadAssetPreview (props) {
    const { customFiles, dispatch, page, ut } = useContext(EasybakeContext)
    const { assetFiles } = props || {}

    function cancel() {
        let isUploaded = arr => arr.every( fileType => customFiles.filter( file => file.assetType === fileType).length > 0);
        if (isUploaded(assetFiles)) {
            analytics.sendEventName('click', `${page}:runapi:cancel`)
        } else {
            const missing = assetFiles.find( fileType => customFiles.filter( file => file.assetType !== fileType).length > 0);
            analytics.sendEventName('click', `${page}:upload:cancel:${missing}`)
        }
        dispatch({ type: 'set-customFiles', payload: { customFiles: [] } })
    }

    function goNext(e) {
        try {
            analytics.sendEventName('click', `${page}:upload:continue`)
            let isUploaded = arr => arr.every( fileType => customFiles.filter( file => file.assetType === fileType).length > 0);
            if (isUploaded(assetFiles)) {
                dispatch({ type: 'set-isApiReady', payload: {isApiReady: true} })
                dispatch({ type: 'set-isApiDone', payload: {isApiDone: false} })
            } else {
                dispatch({ type: 'upload', payload: true })
            }
        } catch(e) {
            logAlert(e)
        }
    }

    function removeFile(e, file) {
        analytics.sendEventName('click', `${page}:upload:remove:${file.type}`)
        let newCustomFiles = customFiles.filter( obj => {
            if (file.path) {
                return obj.path !== file.path
            } else {
                return obj.tempUrls.id !== file.tempUrls.id
            }
        });
        dispatch({ type: 'set-customFiles', payload: { customFiles: newCustomFiles } })
    }

    function getThumbnail(file) {
        return <img
            className="adobe-easybake-customFiles-thumbnail"
            alt={file.name}
            src={file.thumbnail} />
    }

    function getCustomFilesContents() {
        const comps = customFiles.map( file => {
            const assetType = file.assetType === 'image' ? 'image' : 'file'
            return <div key={file.path ? file.path : file.url.id}>
                <div className="adobe-easybake-customFiles-assetType-title">{`${file.assetType} file:`}</div>
                <div className="adobe-easybake-customFiles-row">
                    <div className="adobe-easybake-row">
                        <div className="adobe-easybake-customFiles-thumbnail-frame">
                            { assetType === 'image' ? 
                            getThumbnail(file) :
                            <img
                                className="adobe-easybake-customFiles-atn-thumbnail"
                                alt="image"
                                src={AtnLogo} />}
                        </div>
                        <div className="adobe-easybake-customFiles-name">
                            {file.name}
                        </div>
                    </div>
                    <div>
                        <Button quiet variant="action" onClick={ e => removeFile(e, file) } icon={<Delete />}>Remove</Button>
                    </div>
                </div>
                    <hr className="adobe-easybake-customFiles-hr" />
            </div>
        })
        return <div className="adobe-easybake-customFiles-table">{comps}</div>
    }

    return <div className="adobe-easybake-main-pane-upload">
        <div className="adobe-easybake-upload-asset-div">
            <br />
            <Title title="Uploaded Files" />
            <br />
            <DropZone
                className="adobe-easybake-custom-files-drop-zone-preview" >
                { customFiles && customFiles.length > 0 && getCustomFilesContents() }
            </DropZone>
            <br />
            <div className="adobe-easybake-flex-row-button-right-aligned">
                <Button variant="primary" onClick={ e => cancel(e) }>{__('btn_cancel')}</Button>
                <Button quiet variant="cta" onClick={ e => goNext(e) }>{__('btn_continue')}</Button>
            </div>
        </div>
    </div>
}